import type { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import type { UserRole } from "../types";
import { useSessionStore } from "../store/sessionStore";

interface RoleGuardProps {
  requires: UserRole;
  children: ReactNode;
}

/** Sends users without the required role to the Forbidden page. */
export function RoleGuard({ requires, children }: RoleGuardProps) {
  const role = useSessionStore((state) => state.role);

  if (role !== requires) return <Navigate to="/uw/forbidden" replace />;

  return <>{children}</>;
}
